import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../crt-route-config'

export const Route = createFileRoute(
  '/_auth/_modules/crt/volume-forecasts/nc-provincial-contributions',
)({
  staticData: toStaticData(CRT_ROUTES['/crt/volume-forecasts/nc-provincial-contributions']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
